import MetabaseAppDashboard from 'features/MetabaseAppDashboard';

function ExternalReportPage() {
  return (
    <div>
      <MetabaseAppDashboard />
    </div>
  );
}

export default ExternalReportPage;
